export const VIEW_SETTING = 'TEAM_CAPACITY_VIEW_INTERVAL';

export const VIEW_SETTING_VALUES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  BETA_WEEKLY: 'BETA_WEEKLY',
} as const;
